import { default as styled } from 'styled-components';

export const Container = styled.div`
  margin-top: 32px;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    margin-top: 50px;
  }
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
`;
